.container {
  margin-top: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-2);
  background: var(--tuna-palette-action-hover);
  border-radius: var(--tuna-shape-radius-sm);
  display: flex;
  justify-content: flex-start;
}

.link {
  /* Sized by ui-lib Button size="small"; class reserved for future tweaks. */
}
